export const LIVEKIT_PROVIDER = 'livekit';

// Announced once this client is fully connected, so the doctor's app can tell "the room
// accepted the patient" (which fires mid-handshake, while this screen is still loading)
// apart from "the patient is actually here".
export const PATIENT_READY_TOPIC = 'telemedicine:patient-ready';
